<template>
  <div class="html">
    <banner :title="title" :content="content"></banner>
    <div class="introduce">
      <p class="sub_title">
        服务介绍
      </p>
      <div class="content_A">
        <div class="content_list">
          <div>
            {{ introduceList }}
          </div>
        </div>
      </div>
    </div>
    <div class="procedures">
      <p class="sub_title">服务流程</p>
      <div class="lists">
        <div v-for="item in processList" :key="item.id" class="list">
          <div class="item_list">
            <div class="content">
              <div :style="{ background: item.color }">{{ item.title }}</div>
              <div v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg_inspect"></div>
    </div>
    <div class="cost" style="margin-top: 120px">
      <p class="sub_title">服务价值</p>
      <div class="lists">
        <div v-for="item in costList" :key="item.id" class="list">
          <div class="item_list">
            <img class="cost_img" :src="item.imgUrl" alt="" />
            <div class="content">
              <p>{{ item.title }}</p>
              <p>{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'inspect',
  components: {
    banner
  },
  data() {
    return {
      title: '安全检查服务',
      content:
        '开展网络与信息系统安全检查工作能充分了解客户信息系统及其所在网络存在的安全隐患。 利用专业网络安全服务人员对客户重点信息系统、 网络进行深入安全检查， 检查信息系统以及网络中存在的弱点， 识别可被黑客用来非法进入网络的漏洞',
      introduceList:
        '安全检查是集资产探测、识别、资产风险排查、POC检测、漏洞验证等技术手段，并结合专业安全服务，为关键信息基础设施资产普查与风险定位提供快速、精准的专业安全服务。 利用资产探测结果，结合漏洞发现检测技术和数据情报分析技术，可以实现对网络空间资产存活状态的快速探测，具备针对全网各类资产的精准发现、精准识别、精准威胁检测能力。依托资产指纹库、CVE漏洞库、POC规则库等丰富的资源库，实现对网络空间资产的准确识别、发现与安全检测， 从而掌握网络空间资产安全风险态势，增强信息系统威胁防护能力，降低资产安全维护管理成本。',
      processList: [
        {
          id: 1,
          title: '01-获得用户授权',
          color: '#4D81EA',
          content: '获得客户单位出具的安全检查授权文件'
        },
        {
          id: 2,
          title: '02-了解现场环境',
          color: '#8096F7',
          content: '了解客户资产基本信息，确定技术检测范围。'
        },
        {
          id: 3,
          title: '03-资产采集及分析',
          color: '#7BA7F6',
          content:
            '· 系统扫描<br/>· Web应用扫描<br/>· 弱口令检查<br/>· 资产搜集'
        },
        {
          id: 4,
          title: '04-风险资产排查',
          color: '#76B4F5',
          content: '检测有效资产范围内的安全漏洞，形成安全风险报告'
        }
      ],
      costList: [
        {
          id: 1,
          title: '资产精准探测',
          imgUrl: require('@/assets/securityServices/inspect1.png'),
          content: '专业资产探测工具，快速、精准发现全网各类资产状况。'
        },
        {
          id: 2,
          title: '保障系统运行',
          imgUrl: require('@/assets/securityServices/inspect2.png'),
          content:
            '通过安全检查服务，分析安全风险，提升安全防护能力，预防和减少网络安全事件发生，保障系统正常运行。'
        },
        {
          id: 3,
          title: '降低运维成本',
          imgUrl: require('@/assets/securityServices/inspect3.png'),
          content:
            '通过周期性的安全检查服务，可以全面摸清资产状况，及时消除安全风险，有效降低运维成本。'
        }
      ]
    }
  }
}
</script>
<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.procedures {
  width: 100%;
  margin-top: 40px;
  background: #fafbff;
  padding-top: 120px;
  padding-bottom: 135px;
  position: relative;
  min-height: 979px;

  .lists {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    top: 340px;
    width: 70%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .list {
      width: 22%;
      margin: 0 1%;

      .item_list {
        width: 100%;
        box-shadow: 1px 1px 10px #dadada;
        min-height: 350px;
        background: #fff;

        .content {
          div:nth-child(1) {
            width: 100%;
            font-size: 24px;
            font-weight: bold;
            color: #ffffff;
            line-height: 40px;
            padding: 80px 0;
            text-align: center;
          }

          div:nth-child(2) {
            width: 80%;
            margin: 0 auto;
            font-size: 22px;
            font-weight: 400;
            color: #333333;
            line-height: 30px;
            padding: 100px 0;
            min-height: 150px;
          }
        }
      }
    }
  }

  .bg_inspect {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 220px;
    width: 70%;
    margin: 0 auto;
    height: 310px;
    background: #d2e2fb;
    z-index: 0;
  }
}
</style>
